import axios from 'axios';

const KEY = 'rs_demo';
const HEADER = 'X-Demo-Mode';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isDemo = () => localStorage.getItem(KEY) === '1';

const applyHeader = () => {
  if (isDemo()) axios.defaults.headers.common[HEADER] = '1';
  else delete axios.defaults.headers.common[HEADER];
};
applyHeader();

export const startDemoSession = async (role) => {
  localStorage.setItem(KEY, '1');
  applyHeader();
  try {
    const res = await axios.post(`${API}/demo/session`, { role }, { headers: { [HEADER]: '1' } });
    return res.data;
  } catch (err) {
    localStorage.removeItem(KEY);
    applyHeader();
    throw err;
  }
};

export const exitDemo = () => {
  localStorage.removeItem(KEY);
  applyHeader();
};
